<section class="content-header subscriber-content-header">
  <div class="container-fluid">
    <div class="card subscriber-config-panel">
      <div class="card-header subscriber-cups-separator no-select">
        <div class="subscriber-cups-separator-title">
          <i class="fas fa-cog subscriber-cups-separator-icon"></i>
          <div class="subscriber-cups-title subscriber-cups-meters-title">
            {{ "configuration" | translate }}
          </div>
        </div>

        <div class="panel-back" title="{{ 'back' | translate }}" (click)="back()">
          <i class="fas fa-chevron-left"></i>
        </div>
      </div>

      @if (userData) {
        <div class="card-body user-form-body subscriber-config-form">
          <!-- Username -->
          <div class="user-form-attribute">
            <mat-form-field appearance="fill">
              <mat-label>{{ "user" | translate }}</mat-label>
              <input
                matInput
                type="text"
                [ngModel]="userData.username | dataProtected"
                (ngModelChange)="!SessionDataService.dataProtectionActive() && (userData.username = $event)"
                [readonly]="SessionDataService.dataProtectionActive()"
                placeholder="{{ 'user' | translate }}..."
                required
              />
            </mat-form-field>
          </div>
          <!-- Name -->
          <div class="user-form-attribute">
            <mat-form-field appearance="fill">
              <mat-label>{{ "name" | translate }}</mat-label>
              <input
                matInput
                type="text"
                [ngModel]="userData.name | dataProtected"
                (ngModelChange)="!SessionDataService.dataProtectionActive() && (userData.name = $event)"
                [readonly]="SessionDataService.dataProtectionActive()"
                placeholder="{{ 'name' | translate }}..."
                required
              />
            </mat-form-field>
          </div>
          <!-- Apellido -->
          <div class="user-form-attribute">
            <mat-form-field appearance="fill">
              <mat-label>{{ "surname" | translate }}</mat-label>
              <input
                matInput
                type="text"
                [ngModel]="userData.surname | dataProtected"
                (ngModelChange)="!SessionDataService.dataProtectionActive() && (userData.surname = $event)"
                [readonly]="SessionDataService.dataProtectionActive()"
                placeholder="{{ 'surname' | translate }}..."
                required
              />
            </mat-form-field>
          </div>
          <!-- Phone -->
          <div class="user-form-attribute">
            <mat-form-field appearance="fill">
              <mat-label>{{ "phone" | translate }}</mat-label>
              <input
                matInput
                type="text"
                onkeypress="return event.charCode >= 48 && event.charCode <= 57;"
                [(ngModel)]="userData.phoneNumber"
                placeholder="{{ 'phone' | translate }}..."
              />
            </mat-form-field>
          </div>
          <!-- Phone 2 -->
          <div class="user-form-attribute">
            <mat-form-field appearance="fill">
              <mat-label>{{ "phone" | translate }} 2</mat-label>
              <input
                matInput
                type="text"
                onkeypress="return event.charCode >= 48 && event.charCode <= 57;"
                [(ngModel)]="userData.phoneNumber2"
                placeholder="{{ 'phone' | translate }}..."
              />
            </mat-form-field>
          </div>
          <!-- Email -->
          <div class="user-form-attribute">
            <mat-form-field appearance="fill">
              <mat-label>Email</mat-label>
              <input matInput type="email" [(ngModel)]="userData.email" placeholder="Email..." />
            </mat-form-field>
          </div>
          <!-- Password -->
          <div class="user-form-attribute">
            <mat-form-field appearance="fill">
              <mat-label>
                {{ "new-password" | translate }}
              </mat-label>
              <input
                matInput
                [type]="showPassword ? 'text' : 'password'"
                [(ngModel)]="userData.password"
                name="password"
                autocomplete="new-password"
                [maxLength]="20"
                [minLength]="10"
                placeholder="{{ 'new-password' | translate }}..."
                title="{{ 'password-requeriment' | translate }}"
              />
            </mat-form-field>
            <!-- Password hint -->
            <div class="user-form-password-icons">
              <i
                class="fas fa-info-circle pointer"
                (click)="showPasswordRequeriments = !showPasswordRequeriments"
              ></i>
              @if (showPasswordRequeriments) {
                <span class="user-form-password-requeriments">
                  {{ "password-requeriment" | translate }}
                </span>
              }
              <i class="fas fa-eye pointer" (click)="showPassword = !showPassword"></i>
            </div>
          </div>
          <!-- Repeat password -->
          <div class="user-form-attribute">
            <mat-form-field appearance="fill">
              <mat-label>
                {{ "password-repeat" | translate }}
              </mat-label>
              <input
                matInput
                [type]="showPassword ? 'text' : 'password'"
                [(ngModel)]="repeatedPassword"
                name="password"
                autocomplete="password-repeat"
                [maxLength]="20"
                [minLength]="10"
                placeholder="{{ 'password-repeat' | translate }}..."
              />
            </mat-form-field>
          </div>
          <!-- Idioma -->
          <div class="user-form-attribute">
            <app-material-select
              [title]="'language' | translate"
              [bindValue]="'id'"
              [bindLabel]="'descripcion'"
              [selected]="languageInitialSelection"
              [data]="languagesList"
              (selectedOption)="userData.language = $event?.id; languageUpdated = true"
              [required]="true"
            ></app-material-select>
          </div>
          <div class="user-form-control">
            <div class="user-form-buttons">
              <!-- Update -->
              <button
                mat-button
                class="mat-button-icon-text"
                [disabled]="
                  userData.username == null ||
                  userData.name == null ||
                  userData.surname == null ||
                  userData.language == null ||
                  userData.password?.length > 0
                    ? 10 > $safeNavigationMigration(userData.password?.length)
                    : null
                "
                (click)="saveUserData()"
              >
                <i class="fas fa-save"></i>
                {{ "save" | translate }}
              </button>
              <!-- Reset -->
              <button mat-button class="mat-button-icon-text" (click)="reset($event)">
                <i class="fas fa-sync-alt"></i>
                {{ "restart" | translate }}
              </button>
            </div>
          </div>
        </div>
      } @else {
        <ng-template [ngTemplateOutlet]="elseBlock"></ng-template>
      }
    </div>
  </div>
</section>
